import CardContent from '@mui/material/CardContent';
import { Card, Container, Divider, Group, Stack, Text, ThemeIcon, Title } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBattery, faBattery4, faChartArea, faCube, faGear } from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';


const DashboardsList = () => {

    return (
        <Stack>
            <Title order={2}>Dashboards</Title>
            <Divider />
            <Group align="normal" p={20}>
                <DashboardPreviewPanel
                    name="Lighthouse"
                    description="Monitor key BESS metrics in real time fleetwide. View open and recent events relevant to BESS operations."
                    relPath="lighthouse"
                    icon={faBattery4}
                />
                <DashboardPreviewPanel
                    name="Tron"
                    description="Discover and explore recent setpoint deviation events."
                    relPath="tron"
                    icon={faChartArea}
                />
            </Group>
        </Stack>
    )
}

const DashboardPreviewPanel = ({name, description, relPath, icon}) => {

    const navigate = useNavigate()

    return (
        <Card p="lg" withBorder className="dash-prvw-panel flow-vertical" style={{maxWidth: "300px"}}>
            <div className="flow-horizontal align-bl" style={{marginBottom: "15px"}}>
                <ThemeIcon>
                    <FontAwesomeIcon icon={icon} />
                </ThemeIcon>
                <Title order={5} ml={6}>{name}</Title>
            </div>
            <Stack style={{flexGrow: 1}}>
                <Text size="sm">{description}</Text>
            </Stack>
            <Card.Section pt="sm">
                <Divider />
                <Group spacing={0} noWrap position="left" align="normal" >
                    <Text
                        onClick={() => navigate(relPath+window.location.search)}
                        size="sm"
                        weight={500}
                        className="section-open"
                        p="sm"
                        style={{flexGrow: 1, borderRight: "solid lightgrey 1px"}}
                    >
                        Open
                    </Text>
                    <Stack
                        onClick={() => navigate(relPath+"/configure"+window.location.search)}
                        p="sm"
                        className="section-configure"
                        justify="center"
                    >
                        <FontAwesomeIcon icon={faGear} size="xl" />
                    </Stack>
                </Group>
            </Card.Section>
        </Card>
    )
}

export default DashboardsList